import { Component, Input, OnInit } from '@angular/core';
import { CodeAndName } from '@lx/shared/types';
import { NgForOf } from '@angular/common';
import { RadioButtonModule } from 'primeng/radiobutton';
import { getCustomFormComponentControlValueAccessorProvider } from '@lx/quote-tool/lite/shared/utils';
import { FormsModule } from '@angular/forms';
import { KeyboardFocusDirective } from '@lx/shared/ui/keyboard-focus';
import { SelectorField } from '@lx/quote-tool/lite/shared/ui/directives';

@Component({
  standalone: true,
  selector: 'lx-yes-no-radio-button',
  imports: [NgForOf, RadioButtonModule, FormsModule, KeyboardFocusDirective],
  templateUrl: './yes-no-radio-button.component.html',
  styleUrls: ['./yes-no-radio-button.component.scss'],
  providers: [getCustomFormComponentControlValueAccessorProvider(YesNoRadioButtonComponent)],
})
export class YesNoRadioButtonComponent extends SelectorField<boolean> implements OnInit {
  @Input() name: string | undefined;

  options: CodeAndName<boolean>[] = [];

  private readonly YES_NO_VALUES: CodeAndName<boolean>[] = [
    { code: true, name: $localize`Yes` },
    { code: false, name: $localize`No` },
  ];

  ngOnInit(): void {
    this.options = this.YES_NO_VALUES;
    if (this.selectedValue === undefined) {
      this.selectedValue = null; // or set to `true` if you want "Yes" preselected
    }
  }
}
